export const DRAFT_ORDERS_ROUTES = {
  newDraftOrder: '/draft-orders/new',
  draftOrderDetails: '/draft-orders/:id',
  draftOrderList: '/draft-orders',
};
